import type { IFileAttachment, IFileAttachmentData } from "./file-attachment.types";
import { AbstractModel } from "../base";

export class FileAttachment extends AbstractModel implements IFileAttachment {
    readonly url: string
    readonly size: number
    readonly name: string
    readonly extension: string

  constructor(data: IFileAttachmentData) {
    super()

    // Validate data
    const requiredFields: (keyof IFileAttachmentData)[] = ['url', 'size', 'name', 'extension']
    this.validate(data, requiredFields)

    // Initialize object assuming data valid
    this.url = data.url!
    this.size = data.size!
    this.name = data.name!
    this.extension = data.extension!
  }
}
